<app-page-content [showBreadcrumb]="false">
  <app-icon icon name="aggregator" class="text-400 mr-2" size="md"></app-icon>
  <ng-container title>{{ "sharedFeatures.Aggregator" | translate }}</ng-container>

  <app-state-section [state]="sectionState" content>
    <div class="redirect-container d-flex align-center justify-center vh-100 raduis-3 my-6">

      <mat-card class="redirect-card w-100 text-center radius-3">
        <mat-card-content>

          <div class="icon-header d-flex align-center justify-center mb-4">
            <div class="external-link-icon pos-relative text-white bg-primary-200 radius-4 p-5">
              <app-icon  name="external-url"></app-icon>
              <div>
                <a href="https://lastmile.madar.app/" target="_self">
                  <app-icon
                    name="right-arrow"
                    class="arrow-badge text-white d-flex align-center justify-center"
                    size="xs">
                  </app-icon>
                </a>
              </div>
            </div>
          </div>

          <h5 class="text-900 h5 weight-semibold">
            {{ "sharedFeatures.MovedTitle" | translate }}
          </h5>

          <p class="text-500 h6">
            {{ "sharedFeatures.Description" | translate }}
          </p>

          <div class="text-left radius-2 p-2 bg-primary-lighter brd brd-1 brd-primary-light mb-4 d-flex align-center">
            <app-icon name="bold-info-circle" class="text-primary-300 mr-2"></app-icon>
            <span class="text-primary-300 small">
              {{ "sharedFeatures.LoginInfo" | translate }}
            </span>
          </div>

          <div class="py-3 px-4 brd brd-1 brd-200 bg-200 mb-4 radius-2 text-left">

            <span class="small text-500">
              {{ "sharedFeatures.NewLocation" | translate }}
            </span>

            <div class="d-flex align-center mb-3 ">
              <app-icon name="external-url" size="xxs" class="mr-2"></app-icon>

              <a  href="https://lastmile.madar.app/" target="_self" class="text-undecorated">
                <span class="text-900 h5 text-undecorated">
                  {{ "sharedFeatures.Url" | translate }}
                </span>
              </a>
            </div>

            <div class="text-left d-flex align-center">
              <app-icon name="outline-star" size="xxs" class="mr-2"></app-icon>

              <span class="small text-500">
                {{ "sharedFeatures.BookmarkNote" | translate }}
              </span>
            </div>

          </div>

          <div class="actions">

            <button  (click)="openB2CPortal('_self')"   mat-flat-button color="primary" class="main-btn d-block w-100 mb-2">
              <app-icon name="right-arrow" size="sm" class="mr-2"></app-icon>
              {{ "sharedFeatures.GoButton" | translate }}
            </button>

            <button (click)="openB2CPortal('_blank')"  mat-button class="text-900 d-block w-100">
              <app-icon name="external-url" size="xs" class="mr-2"></app-icon>
              {{ "sharedFeatures.OpenNewTab" | translate }}
            </button>

          </div>

        </mat-card-content>
      </mat-card>

    </div>

    <p class="text-center small text-500">
      {{ "sharedFeatures.Footer" | translate }}
    </p>

  </app-state-section>
</app-page-content>
